import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-dialog--login__content-container--text"},[_c(VIcon,{staticClass:"login-dialog--login__content-container--text__checkmark",attrs:{"color":"primary","size":"100"}},[_vm._v(_vm._s(_vm.icon))]),_c('h2',{staticClass:"login-dialog--login__content-container--text__title mt-16"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"login-dialog--login__content-container--text__subtitle"},[_vm._v(_vm._s(_vm.description))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }